import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { hrmsGetRequest, hrmsPostRequest, hrmsUpdateRequest, hrmsDeleteRequest } from "../services/index";

const API_URL = "/api/taxes"; // Matches your backend route in server.ts

// Fetch Taxes
export const fetchTaxes = createAsyncThunk("taxes/fetch", async () => {
  const response = await hrmsGetRequest(API_URL);
  console.log("API Response:", response.data);
  return response.data;
});

// Add Tax
export const addTax = createAsyncThunk("taxes/add", async (taxData) => {
  const response = await hrmsPostRequest(API_URL, taxData);
  return response.data;
});

// Update Tax
export const updateTax = createAsyncThunk("taxes/update", async ({ id, updatedData }) => {
  const response = await hrmsUpdateRequest(`${API_URL}/${id}`, updatedData);
  return response.data;
});

// Delete Tax
export const deleteTax = createAsyncThunk("taxes/delete", async (id) => {
  await hrmsDeleteRequest(`${API_URL}/${id}`);
  return id;
});

const taxSlice = createSlice({
  name: "taxes",
  initialState: {
    taxes: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTaxes.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchTaxes.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.taxes = action.payload;
      })
      .addCase(fetchTaxes.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(addTax.fulfilled, (state, action) => {
        state.taxes.push(action.payload);
      })
      .addCase(updateTax.fulfilled, (state, action) => {
        const index = state.taxes.findIndex((t) => t.id === action.payload.id);
        if (index !== -1) {
          state.taxes[index] = action.payload;
        }
      })
      .addCase(deleteTax.fulfilled, (state, action) => {
        state.taxes = state.taxes.filter((t) => t.id !== action.payload);
      });
  },
});

export default taxSlice.reducer;